module.exports = __webpack_public_path__ + "img/郭永林.f4aa8f7f.jpg";